export enum ETransmissionType {
	pathologie = "Pathologie",
	risque = "Risque",
	reactionHumaine = "Réaction humaine"
}